
import moment from 'moment';

export function trierParDateDebut(lignes) {
  if (!Array.isArray(lignes)) {
    return [];
  }

  return [...lignes].sort((a, b) => {
    const da = moment(a.dateDebut);
    const db = moment(b.dateDebut);

    const va = da.isValid();
    const vb = db.isValid();

    if (!va && !vb) return 0;
    if (!va) return 1;   // dates invalides à la fin
    if (!vb) return -1;

    return da.valueOf() - db.valueOf();
  });
}

export function calcPrixTotal(budget) {
  return (budget.prixNet || 0)
    + (budget.tlpe || 0)
    + (budget.fraisTechnique || 0)
    + (budget.honoraires || 0)
    + (budget.honoraireFraisTraitement || 0);
}

export function calculerNbreAnnees(dateDebut, dateFin) {
  const debut = moment(dateDebut);
  const fin = moment(dateFin);
  if (!debut.isValid() || !fin.isValid() || fin.isBefore(debut)) return null;
  fin.add(1, 'd');
  const res = fin.diff(debut, 'y', true);
  return res;
}